import React, { useState, useEffect } from "react";
import { CAMPAIGN_CREATE_LINK } from "../../constants/constants";
import { notifyError } from "../../helper";
import Header from "../Header";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import CampaignHeader from "./CampaignHeader";
import CampaignSummary from "./CampaignSummary";
import CampaignActivity from "./CampaignActivity";
import CampaignTimeline from './CampaignTimeline';
import { useParams } from "react-router-dom";
import client from "../../api";

const CampaignOverview = () => {
    const {campaignID} = useParams('');
    const api = client();
    const [activeTab,setActiveTab] = useState('summary');
    const [campaignPreview, setCampaignPreview] = useState({});
    const [contactList, setContactList] = useState('');
    
    const handleTab = (name) => {
        setActiveTab(name);
    }

    const handleContactListChange = (e) => {
        setContactList(e.target.value);
    }

    useEffect(()=>{
        const getCampaignPreview = async () => {
            try{
                const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
                if(response.status === 200 ||response.status === 201 ){
                    setCampaignPreview(response.data.campaignPreview);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
            }
        }
        getCampaignPreview();
    },[]);
    
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="campaign-pages-wrap">
                <CampaignHeader page={'overview'} campaignID={campaignID} />
                <div className="overview-tabs">
                    <ul>
                        <li>
                        <div className="field-wrap">
                            <select className="selectbox" onChange={handleContactListChange} value={contactList}>
                                <option value="">All recipient List</option>
                                {Object.keys(campaignPreview).length && (campaignPreview.list_details).map((list,i)=>(<option key={i} value={list._id}>{list.name}</option>))}
                                
                            </select>
                            </div>
                        </li>
                        <li onClick={()=>{
                            handleTab('summary');
                        }}><span className={activeTab === 'summary' ? 'selected':''}>Summary</span></li>
                        <li onClick={()=>{
                            handleTab('activity');
                        }}><span className={activeTab === 'activity' ? 'selected':''}>Activity</span></li>
                        <li onClick={()=>{
                            handleTab('timeline');
                        }}><span className={activeTab === 'timeline' ? 'selected':''}>Timeline</span></li>
                    </ul>
                </div>
                {activeTab === 'summary' && <>
                    <CampaignSummary 
                        messageType={campaignPreview?.message_mime_type}
                        trackOpen={campaignPreview?.setting?.track_open}
                        trackClicks={campaignPreview?.setting?.track_clicks} 
                        contactList={contactList} />
                </>}
                {activeTab === 'activity' && <CampaignActivity contactList={contactList} />}
                {activeTab === 'timeline' && <CampaignTimeline contactList={contactList} />}

            </div>
        </div>
        <Footer/>
        </>);
}

export default CampaignOverview;